export const MESSAGES = {
	SEM_INFORMACOES_PDF: 'É necessário cadastrar uma análise para gerar o PDF.',
	SEM_INFORMACOES_PDF_PRESTACAO_CONTAS: 'A prestação de contas não possui informações suficientes para ser exportada em PDF',
	PERIODO_EMISSAO_INVALIDO: 'Data inicial do período de emissão deve ser menor que a data final do período de emissão',
};
